import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { Button } from '@mantine/core';
import { IconCalendarEvent, IconPlus } from '@tabler/icons-react';
import { MaeShell, MaePageHead } from '@/shared/desktop/MaeShell';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';

export const Route = createFileRoute('/_app/instruments-calendar')({ component: BookingsLayoutSelector });

/** Su mobile niente chrome desktop: la schermata mobile porta il proprio header. */
function BookingsLayoutSelector() {
  const isMobile = useIsMobileShell();
  return isMobile ? <Outlet /> : <BookingsLayout />;
}

/**
 * La sezione Prenotazioni: il calendario e basta. L'intestazione è **solo** questa — le pagine
 * figlie non rendono un proprio header, altrimenti si vedrebbero due titoli sovrapposti.
 *
 * Fino al 23-10-2026 c'era una seconda scheda, «Approvazioni», sulla coda vecchia
 * (`/api/bookings/pending-approval-for-me`): leggeva uno stato che il flusso nuovo non scrive, e
 * ci restavano anche le richieste già approvate. Le code vere sono in «Approvazioni» (schede
 * Mezzi, Trasferte, Sale riunioni), e `/instruments-calendar/approvals` ci rimanda.
 */
function BookingsLayout() {
  const navigate = useNavigate();
  return (
    <MaeShell>
      <MaePageHead
        title="Prenotazioni"
        sub="Auto aziendali, trasferte e sale riunioni."
        icon={<IconCalendarEvent size={23} />}
        tone="azzurro"
        actions={
          <Button h={40} leftSection={<IconPlus size={16} />} onClick={() => void navigate({ to: '/bookings/new' })}>
            Nuova prenotazione
          </Button>
        }
      />
      <Outlet />
    </MaeShell>
  );
}
